import dayjs from '#build/dayjs.imports.mjs'

export function useDayjs() {
  return dayjs
}